import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {LoginCompany} from '../types';

export const useApiLoginCompanies = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['login-companies'],
        queryFn: async () => await apiClient.get('/auth/companies') as LoginCompany[]
    });

    return {
        data: data || [] as LoginCompany[],
        isLoading: isLoading
    };
};
